export const TOOLTIP_FIELDS = {
  PLACE_TOP: 'top',
  EFFECT_SOLID: 'solid',
  PLACE_BOTTOM: 'bottom',
  PLACE_LEFT: 'left',
  PLACE_RIGHT: 'right',
  TYPE_ERROR: 'error',
  EFFECT_FLOAT: 'float'
};
